module.exports = __webpack_public_path__ + "static/media/2.d42dbe0c.jpg";